import React from 'react';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.mode === 'dark' ? '#1e1e2e' : '#2d2d3f',
    color: '#f0f0f0',
    fontSize: '0.75rem',
    fontWeight: 400,
    borderRadius: 8,
    padding: '8px 12px',
    maxWidth: 260,
    boxShadow: '0 4px 16px rgba(0,0,0,0.25)',
    lineHeight: 1.5,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.mode === 'dark' ? '#1e1e2e' : '#2d2d3f',
  },
}));

/**
 * PermissionTooltip — consistent "no permission" tooltip used across the app.
 *
 * Usage:
 *   <PermissionTooltip title="You do not have permission to edit this permit.">
 *     <span>
 *       <Button disabled>Edit</Button>
 *     </span>
 *   </PermissionTooltip>
 *
 * When `title` is empty/falsy the tooltip is not shown (button is enabled).
 */
const PermissionTooltip = ({ title, children, placement = 'top', ...props }) => {
  if (!title) return children;

  return (
    <StyledTooltip
      arrow
      placement={placement}
      title={
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: '6px' }}>
          <LockOutlinedIcon sx={{ fontSize: 14, mt: '1px', flexShrink: 0, color: '#ffb74d' }} />
          <span>{title}</span>
        </Box>
      }
      {...props}
    >
      {children}
    </StyledTooltip>
  );
};

export default PermissionTooltip;
